import React from "react";
import ProjectIconUI5 from "../../../../core/gd-components/icons/project/project-icon-ui5";
import ProjectSession from "../../../../core/model2/project/project-session";
import {ItemIconSize} from "../../../../core/gd-components/icons/@const";


type Props = {
    style?              : any
    className?          : string
    project             : ProjectSession
    selected?           : boolean

    onClick?            : callback
}

export default class NavigationMenuItem_WithoutChildren extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        if (this.props.onClick) {
            this.props.onClick()
        }
    }

    render() {
        const classes = Classes('item', this.props.className, {
            selected            : this.props.selected
        });

        // style is required for ReorderList (pointer-events: none)
        return (
            <div className={classes} style={this.props.style} onClick={this.onClick}>
                <div className="row">

                    <ProjectIconUI5 className="icon" project={this.props.project} size={ItemIconSize.SIZE_15}/>

                    <div className="name">{this.props.project.name}</div>
                </div>
            </div>
        )
    }
}
